import {CalendarOutlined} from "@ant-design/icons";
import moment from "moment";

/** Paginated list cevabı `{ rows, dataCount }` veya düz dizi → tek şekle getirir. */
export const normalizeTableData = data => {
    if (!data) return {rows: [], dataCount: 0};
    if (Array.isArray(data)) return {rows: data, dataCount: data.length};
    return {
        rows: data?.rows ?? [],
        dataCount: data?.dataCount ?? data?.rows?.length ?? 0
    };
};

/** Hakediş (payment period) DataTable aksiyon buton renkleri — PaymentPeriodActionButton $bg/$fg */
export const PAYMENT_PERIOD_BTN = {
    calculate: {$bg: "#7EC1FF", $fg: "#1a1a1a"},
    transferToWallet: {$bg: "#2CB82C", $fg: "#ffffff"},
    detail: {$bg: "#DCDC4C", $fg: "#1a1a1a"},
    importExcel: {$bg: "#7EC1FF", $fg: "#1a1a1a"},
    notify: {$bg: "#FFB347", $fg: "#1a1a1a"},
    notifyTest: {$bg: "#FFB347", $fg: "#1a1a1a"},
    update: {$bg: "#B197FC", $fg: "#1a1a1a"},
    delete: {$bg: "#E38A8A", $fg: "#ffffff"}
};

/**
 * ready and available statuses are almost the same with minor differences
 * courier of ready status accepts orders automatically
 * courier of available status accepts orders manually
 */
export const courierStatuses = [
    {value: "ready", name: "Müsait", translation_key: "ready"},
    {value: "assigned", name: "Cevap Bekleniyor", translation_key: "assigned"},
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "busy", name: "Siparişte", translation_key: "busy"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"},
    {value: "waitingForCourier", name: "Transfer bekliyor", translation_key: "waitingForCourier"},
    {
        value: "assignedForTransfer",
        name: "Transfer için atandı",
        translation_key: "assignedForTransfer"
    },
    {value: "onBreak", name: "Mola", translation_key: "onBreak"}
];

export const courierStatusColors = {
    ready: "#90E248",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    assigned: "#af90d4",
    busy: "#af90d4",
    onBreak: "#f79400ff",
    waiting: "#af90d4",
    onTheWayForPickUp: "#f7cd00",
    onPickUpAddress: "#f7cd00",
    busyOnPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    onDeliveryAddress: "#5bbeea",
    busyOnDelivery: "#5bbeea",
    busyOnReturn: "#f19cbb",
    onTheWayForReturn: "#f19cbb",
    onReturnAddress: "#f19cbb",
    waitingForTransfer: "#964ea2",
    assignedForTransfer: "#964ea2",
    onTheWayForTransfer: "#964ea2",
    onTransferAddress: "#964ea2",
    waitingForCourier: "#964ea2",
    busyOnTransfer: "#964ea2",
    maximumWaitingForBreak: "#D85E5A"
};

export const statisticsTotalCourierStatusColors = {
    total: "#525C5E",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    waiting: "#af90d4",
    onPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    busy: "#f7cd00",
    utilization: "#0046a3"
};

export const statisticsCourierStatusColors = {
    ready: "#90E248",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    assigned: "#af90d4",
    busy: "#af90d4",
    waiting: "#af90d4",
    onTheWayForPickUp: "#f7cd00",
    onPickUpAddress: "#f7cd00",
    busyOnPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    onDeliveryAddress: "#5bbeea",
    busyOnDelivery: "#5bbeea",
    busyOnReturn: "#5bbeea",
    onTheWayForReturn: "#5bbeea",
    onReturnAddress: "#5bbeea",
    waitingForTransfer: "#5bbeea",
    onTheWayForTransfer: "#5bbeea",
    onTransferAddress: "#5bbeea",
    waitingForCourier: "#5bbeea",
    busyOnTransfer: "#5bbeea"
};

export const activityColors = {
    true: "#11c310",
    false: "#e22012"
};

export const courierStatusLogTypes = [
    {value: "statusChange", name: "Kurye Durum Değişikliği", translation_key: "statusChange"},
    {
        value: "onboardingStatusChange",
        name: "İşe Alım Durum Değişikliği",
        translation_key: "onboardingStatusChange"
    }
];

export const mapCourierStatuses = [
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "assigned", name: "Cevap Bekleniyor", translation_key: "assigned"},
    {value: "busyOnPickup", name: "Toplama", translation_key: "busyOnPickup"},
    {value: "busyOnDelivery", name: "Teslimat", translation_key: "busyOnDelivery"},
    {value: "busyOnReturn", name: "İade", translation_key: "busyOnReturn"},
    {value: "busyOnTransfer", name: "Transfer", translation_key: "busyOnTransfer"},
    {value: "waitingForCourier", name: "Transfer Bekliyor", translation_key: "waitingForCourier"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"},
    {value: "onBreak", name: "Mola", translation_key: "onBreak"}
];

export const activationSteps = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "candidate", name: "Aday", translation_key: "candidate"},
    {value: "approved", name: "Onaylı", translation_key: "approved"},
    {value: "blocked", name: "Kara Listeye Alındı", translation_key: "blocked"},
    {value: "rejected", name: "Olumsuz", translation_key: "rejected"},
    {value: "terminated", name: "İşten Çıkarma", translation_key: "terminated"}
];

export const activationPhases = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "companySetup", name: "Şirket Kurulum", translation_key: "companySetup"},
    {value: "newApplication", name: "Yeni Başvuru", translation_key: "newApplication"},
    {value: "document", name: "Belge Yükleme", translation_key: "document"},
    {value: "project", name: "Proje", translation_key: "project"},
    {value: "equipment", name: "Ekipman Seçme", translation_key: "equipment"},
    {value: "healthInsurance", name: "Özel Sağlık Sigortası", translation_key: "healthInsurance"},
    {value: "training", name: "İşbaşı Eğitimleri", translation_key: "training"},
    {value: "shiftWaiting", name: "Vardiya Bekleniyor", translation_key: "shiftWaiting"}
];

export const activationSubSteps = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "none", name: "Durum Yok", translation_key: "none"},
    {
        value: "waitingCompanySetup",
        name: "Şirket Kurulumu Beklenmekte",
        translation_key: "waitingCompanySetup"
    },
    {value: "newApplication", name: "Yeni Başvuru", translation_key: "newApplication"},
    {value: "documentsUpload", name: "Evrak Yükleme", translation_key: "documentsUpload"},
    {value: "documentsInReview", name: "Evrak İnceleme", translation_key: "documentsInReview"},
    {
        value: "documentsRejected",
        name: "Belge Güncelleme Beklenmekte",
        translation_key: "documentsRejected"
    },
    {value: "projectWaiting", name: "Proje Beklenmekte", translation_key: "projectWaiting"},
    {value: "healthInsurance", name: "ÖSS Girişi", translation_key: "healthInsurance"},
    {value: "onTheJobTraining", name: "İş Başı Eğitimi", translation_key: "onTheJobTraining"},
    {value: "trainingCompletion", name: "Eğitim Tamamlandı", translation_key: "trainingCompletion"},
    {
        value: "equipmentCompletion",
        name: "Ekipman Tamamlanması Bekleniyor",
        translation_key: "equipmentCompletion"
    },
    {value: "shiftWaiting", name: "Vardiya Bekliyor", translation_key: "shiftWaiting"},
    {
        value: "hasCriminalRecord",
        name: "Adli Sicil Kaydı Nedeniyle",
        translation_key: "hasCriminalRecord",
        isBlockedSubStep: true
    },
    {
        value: "vehicleIssues",
        name: "Motor Olmaması Nedeniyle",
        translation_key: "vehicleIssues",
        isRejectSubStep: true
    },
    {
        value: "outOfProcess",
        name: "Süreçten Çekilme Nedeniyle",
        translation_key: "outOfProcess",
        isRejectSubStep: true
    },
    {
        value: "recruitmentClosed",
        name: "Bölge Alımı Kapalı Olduğu İçin",
        translation_key: "recruitmentClosed",
        isRejectSubStep: true
    },
    {
        value: "cancelledByCourier",
        name: "Kendi İsteğiyle",
        translation_key: "cancelledByCourier"
    },
    {value: "onLeave", name: "İzin/Raporlu", translation_key: "onLeave"},
    {value: "approved", name: "İşe Alım Tamamlanmış", translation_key: "approved"},
    {value: "pendingEvaluation", name: "Değerlendirme", translation_key: "pendingEvaluation"},
    {
        value: "pendingTermination",
        name: "İşten Çıkarma Bekleniyor",
        translation_key: "pendingTermination"
    },
    {
        value: "terminationCompleted",
        name: "İşten Çıkarma Tamamlandı",
        translation_key: "terminationCompleted"
    },
    {value: "blocked", name: "Kara Listeye Alınmış", translation_key: "blocked"},
    {value: "rejected", name: "Olumsuz", translation_key: "rejected"}
];

// VGT-216-1: İşbaşı Eğitimi seçiliyken gösterilen alt-filtre için eğitim durumu seçenekleri.
export const trainingStatuses = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "notStarted", name: "Başlanmadı", translation_key: "notStarted"},
    {value: "pendingApproval", name: "Onay Bekliyor", translation_key: "pendingApproval"},
    {value: "completed", name: "Tamamlandı", translation_key: "completed"}
];

export const personalCompanySetupStatus = [
    {value: "notAnswered", name: "Cevaplanmamış", translation_key: "notAnswered"},
    {value: "selfSetupSelected", name: "Kendisi Kuracak", translation_key: "selfSetupSelected"},
    {value: "supportRequested", name: "Destek Bekleniyor", translation_key: "supportRequested"},
    {value: "completed", name: "Tamamlandı", translation_key: "completed"}
];

export const statisticsTotalCourierStatuses = [
    {value: "total", name: "Toplam"},
    {value: "available", name: "Müsait"},
    {value: "waiting", name: "Bekleme"},
    {value: "onPickup", name: "Toplama"},
    {value: "onDelivery", name: "Teslimat"},
    {value: "unavailable", name: "Meşgul"},
    {value: "onBreak", name: "Mola"},
    {value: "utilization", name: "Utilization"}
];

export const statisticsCourierStatuses = [
    {value: "available", name: "Müsait"},
    {value: "assigned", name: "Cevap Bekleniyor"},
    {value: "onTheWayForPickUp", name: "Toplama"},
    {value: "onPickUpAddress", name: "Toplama"},
    {value: "onDelivery", name: "Teslimat"},
    {value: "onDeliveryAddress", name: "Teslimat"},
    {value: "onReturn", name: "Teslimat"},
    {value: "onTransfer", name: "Teslimat"},
    {value: "waitingForCourier", name: "Teslimat"},
    {value: "unavailable", name: "Meşgul"},
    {value: "onBreak", name: "Mola"}
];

export const changeStatusList = [
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"},
    {value: "onBreak", name: "Mola", translation_key: "onBreak"}
];

export const allowChangeStatuses = new Set(["available", "ready", "unavailable", "onBreak"]);

export const changeFileUploadList = [
    {
        value: "ehliyetfotokopi",
        name: "Ehliyet Fotokopisi",
        translation_key: "driverLicensePhotocopy"
    },
    {
        value: "ehliyetcezasorgupuani",
        name: "Ehliyet Ceza Sorgu Puanı",
        translation_key: "driverLicensePenaltyQueryScore"
    },
    {
        value: "arackuryelericinsrcbelgesi",
        name: "Araç Kuryeler için SRC Belgesi",
        translation_key: "srcCertificate"
    },
    {
        value: "isebaslamabelgesi",
        name: "İşe Başlama/ Giriş Belgesi",
        translation_key: "employmentStartEntryCertificate"
    },
    {value: "vergilevhasi", name: "Vergi Levhası", translation_key: "taxPlate"},
    {value: "adlisicilkaydi", name: "Adli Sicil Kaydı", translation_key: "criminalRecords"},
    {value: "resim", name: "Resim", translation_key: "picture"},
    {value: "aracruhsatlari", name: "Araç Ruhsatları", translation_key: "vehicleLicenses"},
    {value: "kimlikfotosu", name: "Kimlik fotosu ön / Arka", translation_key: "idPhoto"},
    {
        value: "bankahesapcuzdani",
        name: "Banka Hesap Cüzdanı/Belgesi",
        translation_key: "bankPassbook"
    },
    {value: "diger", name: "Diğer", translation_key: "other"}
];

export const receiverColor = "#ff9966";
export const canceledColor = "#cccccc";
export const returnedColor = "#ff9966";
export const deliveredColor = "#8de973";
export const pickupColor = "#b0c4de";
export const subcompanyColor = "rgb(84, 119, 151)";
export const orderTableColors = ["#ff9966"];

export const courierTypes = [
    {value: "motorCourier", name: "Motorlu", translation_key: "motorCourier"},
    {value: "carCourier", name: "Araçlı", translation_key: "carCourier"},
    {value: "pedestrian", name: "Yaya Kurye", translation_key: "pedestrian"},
    {value: "bicycleCourier", name: "Bisikletli Kurye", translation_key: "bicycleCourier"}
];

export const vehicleOwnershipTypes = [
    {value: "own", name: "Kendisinin", translation_key: "own"},
    {value: "rental", name: "Kiralık", translation_key: "rental"}
];

export const courierEmploymentTypes = [
    {value: "esnafCourier", name: "Esnaf Kurye"},
    {value: "payrolledCourier", name: "Bordrolu Kurye"}
];
export const providerCompanies = [
    {value: "vigo", name: "Vigo"},
    {value: "kuryetec", name: "KuryeTec"},
    {value: "vion", name: "Vion"}
];
export const workingTypes = [
    {value: "food", name: "Yemek", translation_key: "food"},
    {value: "cargo", name: "Kargo", translation_key: "cargo"}
];

export const smartLockerProviders = [{value: "pudo", name: "Pudo", translation_key: "pudo"}];

export const defaultPastPeriods = [
    {
        key: "today",
        label: "Bugün",
        icon: CalendarOutlined,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    },
    {
        key: "yesterday",
        label: "Dün",
        icon: CalendarOutlined,
        startDate: moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
        endDate: moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD")
    },
    {
        key: "lastWeek",
        label: "Son 1 Hafta",
        icon: CalendarOutlined,
        startDate: moment()
            .subtract(1, "week")
            .format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    },
    {
        key: "lastMonth",
        label: "Son 1 Ay",
        icon: CalendarOutlined,
        startDate: moment()
            .subtract(1, "month")
            .format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    }
];

export const defaultFuturePeriods = [
    {
        key: "today",
        label: "Bugün",
        icon: CalendarOutlined,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    },
    {
        key: "tomorrow",
        label: "Yarın",
        icon: CalendarOutlined,
        startDate: moment()
            .add(1, "day")
            .format("YYYY-MM-DD"),
        endDate: moment()
            .add(1, "day")
            .format("YYYY-MM-DD")
    },
    {
        key: "nextWeek",
        label: "1 Hafta",
        icon: CalendarOutlined,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment()
            .add(1, "week")
            .format("YYYY-MM-DD")
    },
    {
        key: "nextMonth",
        label: "1 Ay",
        icon: CalendarOutlined,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment()
            .add(1, "month")
            .format("YYYY-MM-DD")
    }
];

export const deliveryStatuses = [
    {
        value: "unapproved",
        name: "Sipariş onay bekliyor",
        shortName: "Onay bekliyor",
        type: "unapproved",
        translation_key: "unapproved"
    },
    {
        value: "inPrep",
        name: "Sipariş hazırlanmakta",
        shortName: "Hazırlanmakta",
        type: "inPrep",
        translation_key: "inPrep"
    },
    {
        value: "unassigned",
        name: "Siparişe kurye atanmamış",
        shortName: "Atanmadı",
        type: "current",
        translation_key: "unassigned"
    },
    {
        value: "rejected",
        name: "Kurye, siparişi kabul etmedi",
        shortName: "Reddedildi",
        type: "current",
        translation_key: "rejected"
    },
    {
        value: "waiting",
        name: "Sipariş beklemede",
        shortName: "Beklemede",
        type: "current",
        translation_key: "waiting"
    },
    {
        value: "onTheWayForPickUp",
        name: "Kurye, hazırlanan siparişi almaya gidiyor",
        shortName: "Toplama Yolunda",
        type: "current",
        translation_key: "onTheWayForPickUp"
    },
    {
        value: "onPickUpAddress",
        name: "Kurye, toplama noktasına ulaştı",
        shortName: "Toplama Noktasında",
        type: "current",
        translation_key: "onPickUpAddress"
    },
    {
        value: "onDelivery",
        name: "Kurye, siparişi teslim etmek üzere yolda",
        shortName: "Teslimat Yolunda",
        type: "current",
        translation_key: "onDelivery"
    },
    {
        value: "onDeliveryAddress",
        name: "Kurye, teslimat noktasına ulaştı",
        shortName: "Teslimatta",
        type: "current",
        translation_key: "onDeliveryAddress"
    },
    {
        value: "onTrial",
        name: "Kurye deneme için bekliyor",
        shortName: "Deneme",
        type: "current",
        translation_key: "onTrial"
    },
    {
        value: "onTheWayForReturn",
        name: "Kurye, toplama noktasına geri dönüyor",
        shortName: "Geri Dönüyor",
        type: "current",
        translation_key: "onTheWayForReturn"
    },
    {
        value: "onReturnAddress",
        name: "Kurye, toplama noktasına ulaştı",
        shortName: "Geri Döndü",
        type: "current",
        translation_key: "onReturnAddress"
    },
    {
        value: "waitingForTransfer",
        name: "Siparişe atanan kuryenin transferi kabul etmesi bekleniyor",
        shortName: "Transfer Bekliyor",
        type: "current",
        translation_key: "waitingForTransfer"
    },
    {
        value: "onTheWayForTransfer",
        name: "Siparişe atanan kurye transfer noktasına gidiyor",
        shortName: "Transfer Yolunda",
        type: "current",
        translation_key: "onTheWayForTransfer"
    },
    {
        value: "onTransferAddress",
        name: "Siparişe atanan kurye transfer noktasında",
        shortName: "Transfer Noktasında",
        type: "current",
        translation_key: "onTransferAddress"
    },
    {
        value: "delivered",
        name: "Sipariş tamamlandı",
        shortName: "Teslim Edildi",
        type: "past",
        translation_key: "delivered"
    },
    {
        value: "canceled",
        name: "Sipariş iptal edildi",
        shortName: "İptal Edildi",
        type: "past",
        translation_key: "canceled"
    },
    {
        value: "inQueue",
        name: "Sipariş kuyrukta bekliyor",
        shortName: "Sipariş Kuyrukta",
        type: "inQueue",
        translation_key: "inQueue"
    },
    {
        value: "returned",
        name: "Sipariş iptal edildi ürünler iade edildi.",
        shortName: "İade Edildi",
        type: "past",
        translation_key: "returned"
    }
];

export const deliveryStatusEnum = Object.freeze({
    UNASSIGNED: "unassigned",
    REJECTED: "rejected",
    WAITING: "waiting",
    WAITING_FOR_TRANSFER: "waitingForTransfer",
    ON_THE_WAY_FOR_TRANSFER: "onTheWayForTransfer",
    ON_TRANSFER_ADDRESS: "onTransferAddress",
    ON_THE_WAY_FOR_PICK_UP: "onTheWayForPickUp",
    ON_PICK_UP_ADDRESS: "onPickUpAddress",
    ON_DELIVERY: "onDelivery",
    ON_DELIVERY_ADDRESS: "onDeliveryAddress",
    ON_THE_WAY_FOR_RETURN: "onTheWayForReturn",
    ON_RETURN_ADDRESS: "onReturnAddress",
    DELIVERED: "delivered",
    CANCELED: "canceled",
    MERGED: "merged",
    IN_QUEUE: "inQueue",
    IN_PREP: "inPrep",
    UNAPPROVED: "unapproved"
});

export const mapDeliveryStatuses = [
    {value: "unassigned", name: "Siparişe kurye atanmamış"},
    {value: "rejected", name: "Kurye siparişi kabul etmedi"},
    {value: "inPrep", name: "Sipariş hazırlanmakta"},
    {value: "inQueue", name: "Sipariş kuyrukta bekliyor"},
    {value: "waiting", name: "Sipariş beklemede"},
    {value: "onTheWayForPickUp", name: "Kurye, hazırlanan siparişi almaya gidiyor"},
    {value: "approachToCompany", name: "Kurye, toplama noktasına yaklaştı"},
    {value: "onPickUpAddress", name: "Kurye, toplama noktasına ulaştı"},
    {value: "onDelivery", name: "Kurye, siparişi teslim etmek üzere yolda"},
    {value: "approachToReceiver", name: "Kurye, teslimat noktasına yaklaştı"},
    {value: "onDeliveryAddress", name: "Kurye, teslimat noktasına ulaştı"},
    {value: "waitingForReturn", name: "Sipariş, iade edilmek üzere bekleniyor"},
    {value: "onTheWayForReturn", name: "Kurye, toplama noktasına geri dönüyor"},
    {value: "onReturnAddress", name: "Kurye, toplama noktasına ulaştı"},
    {value: "waitingForTransfer", name: "Siparişe atanan kuryenin kabul etmesi bekleniyor"},
    {value: "onTheWayForTransfer", name: "Siparişe atanan kurye transfer noktasına gidiyor"},
    {value: "onTransferAddress", name: "Siparişe atanan kurye transfer noktasında"},
    {value: "delivered", name: "Sipariş tamamlandı"},
    {value: "canceled", name: "Sipariş iptal edildi"},
    {value: "returned", name: "Sipariş iade edildi"}
];

export const orderStatuses = [
    {
        value: "waitingForDelivery",
        name: "Müşteri siparişi bekliyor",
        translation_key: "waitingForDelivery"
    },
    {value: "delivered", name: "Sipariş tamamlandı", translation_key: "delivered"},
    {value: "passed", name: "Sipariş pas geçildi", translation_key: "passed"},
    {value: "reOrdered", name: "Tekrar sipariş verildi", translation_key: "reOrdered"},
    {
        value: "waitingForReturn",
        name: "Sipariş, iade edilmek üzere bekliyor",
        translation_key: "waitingForReturn"
    },
    {value: "returned", name: "Sipariş, iade edildi", translation_key: "returned"}
];

export const cities = [
    {value: "all", name: "Tümü", center: {lat: 40.22, lng: 32.35}, zoom: 7},
    {
        value: "adana",
        name: "Adana",
        center: {
            lat: 37,
            lng: 35.321333
        },
        zoom: 10
    },
    {
        value: "adıyaman",
        name: "Adıyaman",
        center: {
            lat: 37.764751,
            lng: 38.278561
        },
        zoom: 10
    },
    {
        value: "afyonkarahisar",
        name: "Afyonkarahisar",
        center: {
            lat: 38.750714,
            lng: 30.556692
        },
        zoom: 10
    },
    {
        value: "ağrı",
        name: "Ağrı",
        center: {
            lat: 39.626922,
            lng: 43.021596
        },
        zoom: 10
    },
    {
        value: "aksaray",
        name: "Aksaray",
        center: {
            lat: 38.36869,
            lng: 34.03698
        },
        zoom: 10
    },
    {
        value: "amasya",
        name: "Amasya",
        center: {
            lat: 40.64991,
            lng: 35.83532
        },
        zoom: 10
    },
    {
        value: "ankara",
        name: "Ankara",
        center: {
            lat: 39.92077,
            lng: 32.85411
        },
        zoom: 10
    },
    {
        value: "antalya",
        name: "Antalya",
        center: {
            lat: 36.88414,
            lng: 30.70563
        },
        zoom: 10
    },
    {
        value: "ardahan",
        name: "Ardahan",
        center: {
            lat: 41.110481,
            lng: 42.702171
        },
        zoom: 10
    },
    {
        value: "artvin",
        name: "Artvin",
        center: {
            lat: 41.18277,
            lng: 41.818292
        },
        zoom: 10
    },
    {
        value: "aydın",
        name: "Aydın",
        center: {
            lat: 37.856041,
            lng: 27.841631
        },
        zoom: 10
    },
    {
        value: "balıkesir",
        name: "Balıkesir",
        center: {
            lat: 39.648369,
            lng: 27.88261
        },
        zoom: 10
    },
    {
        value: "bartın",
        name: "Bartın",
        center: {
            lat: 41.581051,
            lng: 32.460979
        },
        zoom: 10
    },
    {
        value: "batman",
        name: "Batman",
        center: {
            lat: 37.881168,
            lng: 41.13509
        },
        zoom: 10
    },
    {
        value: "bayburt",
        name: "Bayburt",
        center: {
            lat: 40.255169,
            lng: 40.22488
        },
        zoom: 10
    },
    {
        value: "bilecik",
        name: "Bilecik",
        center: {
            lat: 40.056656,
            lng: 30.066524
        },
        zoom: 10
    },
    {
        value: "bingöl",
        name: "Bingöl",
        center: {
            lat: 39.062635,
            lng: 40.76961
        },
        zoom: 10
    },
    {
        value: "bitlis",
        name: "Bitlis",
        center: {
            lat: 38.393799,
            lng: 42.12318
        },
        zoom: 10
    },
    {
        value: "bolu",
        name: "Bolu",
        center: {
            lat: 40.575977,
            lng: 31.578809
        },
        zoom: 10
    },
    {
        value: "burdur",
        name: "Burdur",
        center: {
            lat: 37.461267,
            lng: 30.066524
        },
        zoom: 10
    },
    {
        value: "bursa",
        name: "Bursa",
        center: {
            lat: 40.266864,
            lng: 29.063448
        },
        zoom: 10
    },
    {
        value: "çanakkale",
        name: "Çanakkale",
        center: {
            lat: 40.155312,
            lng: 26.41416
        },
        zoom: 10
    },
    {
        value: "çankırı",
        name: "Çankırı",
        center: {
            lat: 40.601343,
            lng: 33.613421
        },
        zoom: 10
    },
    {
        value: "çorum",
        name: "Çorum",
        center: {
            lat: 40.550556,
            lng: 34.955556
        },
        zoom: 10
    },
    {
        value: "denizli",
        name: "Denizli",
        center: {
            lat: 37.77652,
            lng: 29.08639
        },
        zoom: 10
    },
    {
        value: "diyarbakır",
        name: "Diyarbakır",
        center: {
            lat: 37.91441,
            lng: 40.230629
        },
        zoom: 10
    },
    {
        value: "düzce",
        name: "Düzce",
        center: {
            lat: 40.843849,
            lng: 31.15654
        },
        zoom: 10
    },
    {
        value: "edirne",
        name: "Edirne",
        center: {
            lat: 41.681808,
            lng: 26.562269
        },
        zoom: 10
    },
    {
        value: "elazığ",
        name: "Elazığ",
        center: {
            lat: 38.680969,
            lng: 39.226398
        },
        zoom: 10
    },
    {
        value: "erzincan",
        name: "Erzincan",
        center: {
            lat: 39.75,
            lng: 39.5
        },
        zoom: 10
    },
    {
        value: "erzurum",
        name: "Erzurum",
        center: {
            lat: 39.9,
            lng: 41.27
        },
        zoom: 10
    },
    {
        value: "eskişehir",
        name: "Eskişehir",
        center: {
            lat: 39.776667,
            lng: 30.520556
        },
        zoom: 10
    },
    {
        value: "gaziantep",
        name: "Gaziantep",
        center: {
            lat: 37.06622,
            lng: 37.38332
        },
        zoom: 10
    },
    {
        value: "giresun",
        name: "Giresun",
        center: {
            lat: 40.912811,
            lng: 38.38953
        },
        zoom: 10
    },
    {
        value: "gümüşhane",
        name: "Gümüşhane",
        center: {
            lat: 40.438588,
            lng: 39.508556
        },
        zoom: 10
    },
    {
        value: "hakkari",
        name: "Hakkari",
        center: {
            lat: 37.583333,
            lng: 43.733333
        },
        zoom: 10
    },
    {
        value: "hatay",
        name: "Hatay",
        center: {
            lat: 36.401849,
            lng: 36.34981
        },
        zoom: 10
    },
    {
        value: "ığdır",
        name: "Iğdır",
        center: {
            lat: 39.887984,
            lng: 44.004836
        },
        zoom: 10
    },
    {
        value: "ısparta",
        name: "Isparta",
        center: {
            lat: 37.764771,
            lng: 30.556561
        },
        zoom: 10
    },
    {
        value: "istanbul",
        name: "İstanbul",
        center: {
            lat: 41.00527,
            lng: 28.97696
        },
        zoom: 10
    },
    {
        value: "izmir",
        name: "İzmir",
        center: {
            lat: 38.41885,
            lng: 27.12872
        },
        zoom: 10
    },
    {
        value: "kahramanmaraş",
        name: "Kahramanmaraş",
        center: {
            lat: 37.585831,
            lng: 36.937149
        },
        zoom: 10
    },
    {
        value: "karabük",
        name: "Karabük",
        center: {
            lat: 41.2061,
            lng: 32.62035
        },
        zoom: 10
    },
    {
        value: "karaman",
        name: "Karaman",
        center: {
            lat: 37.17593,
            lng: 33.228748
        },
        zoom: 10
    },
    {
        value: "kars",
        name: "Kars",
        center: {
            lat: 40.616667,
            lng: 43.1
        },
        zoom: 10
    },
    {
        value: "kastamonu",
        name: "Kastamonu",
        center: {
            lat: 41.38871,
            lng: 33.78273
        },
        zoom: 10
    },
    {
        value: "kayseri",
        name: "Kayseri",
        center: {
            lat: 38.73122,
            lng: 35.478729
        },
        zoom: 10
    },
    {
        value: "kırıkkale",
        name: "Kırıkkale",
        center: {
            lat: 39.846821,
            lng: 33.515251
        },
        zoom: 10
    },
    {
        value: "kırklareli",
        name: "Kırklareli",
        center: {
            lat: 41.733333,
            lng: 27.216667
        },
        zoom: 10
    },
    {
        value: "kırşehir",
        name: "Kırşehir",
        center: {
            lat: 39.14249,
            lng: 34.17091
        },
        zoom: 10
    },
    {
        value: "kilis",
        name: "Kilis",
        center: {
            lat: 36.718399,
            lng: 37.12122
        },
        zoom: 10
    },
    {
        value: "kocaeli",
        name: "Kocaeli",
        center: {
            lat: 40.85327,
            lng: 29.88152
        },
        zoom: 10
    },
    {
        value: "konya",
        name: "Konya",
        center: {
            lat: 37.866667,
            lng: 32.483333
        },
        zoom: 10
    },
    {
        value: "kütahya",
        name: "Kütahya",
        center: {
            lat: 39.416667,
            lng: 29.983333
        },
        zoom: 10
    },
    {
        value: "malatya",
        name: "Malatya",
        center: {
            lat: 38.35519,
            lng: 38.30946
        },
        zoom: 10
    },
    {
        value: "manisa",
        name: "Manisa",
        center: {
            lat: 38.619099,
            lng: 27.428921
        },
        zoom: 10
    },
    {
        value: "mardin",
        name: "Mardin",
        center: {
            lat: 37.321163,
            lng: 40.724477
        },
        zoom: 10
    },
    {
        value: "mersin",
        name: "Mersin",
        center: {
            lat: 36.8,
            lng: 34.633333
        },
        zoom: 10
    },
    {
        value: "muğla",
        name: "Muğla",
        center: {
            lat: 37.215278,
            lng: 28.363611
        },
        zoom: 10
    },
    {
        value: "muş",
        name: "Muş",
        center: {
            lat: 38.946189,
            lng: 41.753893
        },
        zoom: 10
    },
    {
        value: "nevşehir",
        name: "Nevşehir",
        center: {
            lat: 38.69394,
            lng: 34.685651
        },
        zoom: 10
    },
    {
        value: "niğde",
        name: "Niğde",
        center: {
            lat: 37.966667,
            lng: 34.683333
        },
        zoom: 10
    },
    {
        value: "ordu",
        name: "Ordu",
        center: {
            lat: 40.983879,
            lng: 37.876411
        },
        zoom: 10
    },
    {
        value: "osmaniye",
        name: "Osmaniye",
        center: {
            lat: 37.213026,
            lng: 36.176261
        },
        zoom: 10
    },
    {
        value: "rize",
        name: "Rize",
        center: {
            lat: 41.02005,
            lng: 40.523449
        },
        zoom: 10
    },
    {
        value: "sakarya",
        name: "Sakarya",
        center: {
            lat: 40.693997,
            lng: 30.435763
        },
        zoom: 10
    },
    {
        value: "samsun",
        name: "Samsun",
        center: {
            lat: 41.292782,
            lng: 36.33128
        },
        zoom: 10
    },
    {
        value: "siirt",
        name: "Siirt",
        center: {
            lat: 37.933333,
            lng: 41.95
        },
        zoom: 10
    },
    {
        value: "sinop",
        name: "Sinop",
        center: {
            lat: 42.02314,
            lng: 35.153069
        },
        zoom: 10
    },
    {
        value: "sivas",
        name: "Sivas",
        center: {
            lat: 39.747662,
            lng: 37.017879
        },
        zoom: 10
    },
    {
        value: "şanlıurfa",
        name: "Şanlıurfa",
        center: {
            lat: 37.159149,
            lng: 38.796909
        },
        zoom: 10
    },
    {
        value: "şırnak",
        name: "Şırnak",
        center: {
            lat: 37.418748,
            lng: 42.491834
        },
        zoom: 10
    },
    {
        value: "tekirdağ",
        name: "Tekirdağ",
        center: {
            lat: 40.983333,
            lng: 27.516667
        },
        zoom: 10
    },
    {
        value: "tokat",
        name: "Tokat",
        center: {
            lat: 40.316667,
            lng: 36.55
        },
        zoom: 10
    },
    {
        value: "trabzon",
        name: "Trabzon",
        center: {
            lat: 41.00145,
            lng: 39.7178
        },
        zoom: 10
    },
    {
        value: "tunceli",
        name: "Tunceli",
        center: {
            lat: 39.307355,
            lng: 39.438778
        },
        zoom: 10
    },
    {
        value: "uşak",
        name: "Uşak",
        center: {
            lat: 38.682301,
            lng: 29.40819
        },
        zoom: 10
    },
    {
        value: "van",
        name: "Van",
        center: {
            lat: 38.48914,
            lng: 43.40889
        },
        zoom: 10
    },
    {
        value: "yalova",
        name: "Yalova",
        center: {
            lat: 40.65,
            lng: 29.266667
        },
        zoom: 10
    },
    {
        value: "yozgat",
        name: "Yozgat",
        center: {
            lat: 39.818081,
            lng: 34.81469
        },
        zoom: 10
    },
    {
        value: "zonguldak",
        name: "Zonguldak",
        center: {
            lat: 41.456409,
            lng: 31.798731
        },
        zoom: 10
    }
];

export const selectReasons = [
    {id: 1, value: "cancelDueToCompany", label: "İşletme Kaynaklı", translation_key: "company"},
    {id: 2, value: "cancelDueToCustomer", label: "Müşteri Kaynaklı", translation_key: "customer"},
    {id: 3, value: "cancelDueToCourier", label: "Kurye Kaynaklı", translation_key: "courier"},
    {id: 4, value: "manuelDelivered", label: "Manuel Teslim", translation_key: "manuelDelivered"},
    {id: 6, value: "addressIsFar", label: "Uzak Adres", translation_key: "addressIsFar"},
    {
        id: 7,
        value: "customerNotAtAddress",
        label: "Müşteri Adreste Yok",
        translation_key: "customerNotAtAddress"
    },
    {
        id: 8,
        value: "desiLimitExceeded",
        label: "Hacimli Ürün",
        translation_key: "desiLimitExceeded"
    },
    {
        id: 9,
        value: "addressIsIncorrect",
        label: "Adres Hatalı",
        translation_key: "addressIsIncorrect"
    },
    {
        id: 10,
        value: "outOfDeliveryZone",
        label: "Dağıtım Bölgesi Dışında",
        translation_key: "outOfDeliveryZone"
    },
    {id: 5, value: "other", label: "Diğer", translation_key: "other"}
];

export const productReturnSelectReasons = [
    {id: 0, value: "Teslim Alınamadı", label: "Teslim Alınamadı"},
    ...selectReasons
];

export const courierReportReasons = [
    {id: 1, value: "Kurye Gelmedi", label: "Kurye Gelmedi", translation_key: "courierNotArrived"},
    {id: 2, value: "Kurye Hasta", label: "Kurye Hasta", translation_key: "courierHasPatient"},
    {
        id: 3,
        value: "Kurye Ekipmanı Eksik",
        label: "Kurye Ekipmanı Eksik",
        translation_key: "courierHasMissing"
    },
    {id: 4, value: "0", label: "Diğer", translation_key: "other"}
];

export const userTypes = [
    {value: "admin", name: "Admin", translation_key: "admin"},
    {value: "cUser", name: "3. Taraf Firma Kullanıcısı", translation_key: "cUser"},
    {value: "finance", name: "Finans", translation_key: "finance"},
    {value: "hr", name: "İK", translation_key: "hr"},
    {value: "hrEmployment", name: "İK İşe Alım", translation_key: "hrEmployment"},
    {value: "equipmentManager", name: "Ekipman", translation_key: "equipmentManager"},
    {value: "ik", name: "İK İşe Alım(Bölge Tanımlı)", translation_key: "ik"},
    {value: "oUser", name: "Operasyon", translation_key: "oUser"},
    {value: "operationSupport", name: "Operasyon Destek", translation_key: "operationSupport"},
    {value: "sOperation", name: "S-Operasyon", translation_key: "sOperation"},
    {value: "sChef", name: "Saha Şefi", translation_key: "sChef"},
    {value: "data", name: "Data", translation_key: "data"},
    {
        value: "operationImproving",
        name: "Operasyon Geliştirme",
        translation_key: "operationImproving"
    },
    {value: "software", name: "Yazılım", translation_key: "software"},
    {value: "marketing", name: "Pazarlama", translation_key: "marketing"},
    {value: "seller", name: "Bayi", translation_key: "seller"},
    {value: "bm", name: "Bölge Müdürü", translation_key: "bm"},
    {value: "sy", name: "Saha Yöneticisi", translation_key: "sy"},
    {value: "agency", name: "Acente", translation_key: "agency"},
    {value: "agencyIk", name: "Acente-İK", translation_key: "agencyIk"},
    {value: "subAgency", name: "Acente Temsilcisi", translation_key: "subAgency"},
    {value: "sales", name: "Satış", translation_key: "sales"}
];

// Acentenin Kullanıcılar ekranında oluşturabildiği ve görebildiği roller.
export const agencyManagedRoles = ["cUser", "subAgency"];
// Acentenin kullanıcı listesinde görebildiği roller; Acente-İK yalnızca görüntülenir, oluşturulamaz
export const agencyListedRoles = [...agencyManagedRoles, "agencyIk"];

/* 
const statuses = Object.freeze({
    created: "created",
    cancelled: "cancelled",
});

const feeTypes = Object.freeze({
    package: "PAKET",
    distance: "KM",
    hourlyEarnings: "SAATLIK_UCRET",
    hourlyGuaranteeEarnings: "SAATLIK_GARANTI_UCRET",
    bonusPackageEarnings: "BONUS_PAKET_KAZANCI_UCRETI",
});

const feeTypesCompare = Object.freeze({
    package: "PAKET",
    distance: "KM",
    hourlyEarnings: "SAATLIK_UCRET",
});
 */

export const paymentContractActivityStatuses = [
    {value: "cancelled", name: "İptal Edildi", translation_key: "cancelled", color: "red"}, //kırmızı
    {value: "inactive", name: "Pasif", translation_key: "inactive", color: undefined}, //gri
    {value: "active", name: "Aktif", translation_key: "active", color: "green"}, //yeşil
    {value: "future", name: "Beklemede", translation_key: "future", color: "blue"} //açık mavi
];

export const paymentContractFeeTypes = [
    {value: "PAKET", name: "Paket", translation_key: "package"},
    {value: "SAATLIK_UCRET", name: "Saatlik Ücret", translation_key: "hourlyEarnings"},
    {value: "KM", name: "Mesafe", translation_key: "distance"},
    {
        value: "SAATLIK_GARANTI_PAKET",
        name: "Saatlik Paket Garanti",
        translation_key: "hourlyGuaranteePackage"
    },
    {
        value: "BONUS_PAKET_KAZANCI_UCRETI",
        name: "Bonus Paket Kazanç Ücreti",
        translation_key: "bonusPackageEarnings"
    }
];

export const paymentContractFeeTypesCompare = [
    {value: "PAKET", name: "Paket", translation_key: "package"},
    {value: "KM", name: "Mesafe", translation_key: "distance"},
    {value: "SAATLIK_UCRET", name: "Saatlik Ücret", translation_key: "hourlyEarnings"},
    {
        value: "BONUS_PAKET_KAZANCI_UCRETI",
        name: "Bonus Paket Kazanç Ücreti",
        translation_key: "bonusPackageEarnings"
    }
];

export const workTypes = [
    {
        value: "dedicated",
        name: "Dedike",
        translation_key: "dedicated"
    },
    {
        value: "pool",
        name: "Havuz",
        translation_key: "pool"
    },
    {
        value: "dedicatedIntegration",
        name: "Dedike Entegrasyon",
        translation_key: "dedicatedIntegration"
    }
];

export const bloodTypes = [
    "A Rh+",
    "A Rh-",
    "B Rh+",
    "B Rh-",
    "AB Rh+",
    "AB Rh-",
    "0 Rh+",
    "0 Rh-"
];

export const colorPalette = [
    "#0D0D0D",
    "#5D478B",
    "#4169E1",
    "#00C78C",
    "#EE3B3B",
    "#66CDAA",
    "#556B2F",
    "#9AC0CD",
    "#DDA0DD",
    "#EE6AA7",
    "#8B3A62",
    "#8E8E38",
    "#009ACD",
    "#00CD00",
    "#EE6363",
    "#F4F4F4",
    "#00E5EE",
    "#EE00EE",
    "#FFEFDB",
    "#8B814C",
    "#FF6347",
    "#DEDEDE",
    "#551A8B",
    "#555555",
    "#E0EEEE",
    "#EED5B7",
    "#F2F2F2",
    "#FFB6C1",
    "#949494",
    "#D6D6D6",
    "#B23AEE",
    "#D2691E",
    "#1C86EE",
    "#87CEFA",
    "#6E8B3D",
    "#F0F0F0",
    "#D1D1D1",
    "#C1CDC1",
    "#8EE5EE",
    "#C4C4C4",
    "#CD2626",
    "#308014",
    "#707070",
    "#EEDFCC",
    "#BCEE68",
    "#FFEFD5",
    "#B452CD",
    "#FF3030",
    "#EEE685",
    "#808069",
    "#8B4789",
    "#0000FF",
    "#C1FFC1",
    "#00FF00",
    "#54FF9F",
    "#00EE76",
    "#8B7B8B",
    "#9ACD32",
    "#607B8B",
    "#A3A3A3",
    "#53868B",
    "#9400D3",
    "#8B3A3A",
    "#838B83",
    "#F8F8FF",
    "#1F1F1F",
    "#00C957",
    "#43CD80",
    "#8B6914",
    "#FF7256",
    "#F5F5F5",
    "#FFEC8B",
    "#68228B",
    "#7A7A7A",
    "#A0522D",
    "#27408B",
    "#8B864E",
    "#8DEEEE",
    "#858585",
    "#B2DFEE",
    "#8B8B00",
    "#242424",
    "#008000",
    "#C76114",
    "#000080",
    "#388E8E",
    "#8DB6CD",
    "#00688B",
    "#CD3333",
    "#4A4A4A",
    "#CDC0B0",
    "#B0171F",
    "#00CED1",
    "#33A1C9",
    "#CAFF70",
    "#FFA500",
    "#00BFFF",
    "#A9A9A9",
    "#191970",
    "#7FFFD4",
    "#282828",
    "#8B0A50",
    "#FFE4B5",
    "#9A32CD",
    "#969696",
    "#CD661D",
    "#D2B48C",
    "#FFC125",
    "#CD5C5C",
    "#CD5B45",
    "#EEE8AA",
    "#CDC8B1",
    "#7CCD7C",
    "#CD3278",
    "#EEE8CD",
    "#7D7D7D",
    "#FFD39B",
    "#E0FFFF",
    "#BA55D3",
    "#8B8682",
    "#212121",
    "#8B6969",
    "#473C8B",
    "#DB7093",
    "#EE4000",
    "#FA8072",
    "#2B2B2B",
    "#FF00FF",
    "#B4CDCD",
    "#C2C2C2",
    "#6E7B8B",
    "#3D59AB",
    "#8A2BE2",
    "#F0E68C",
    "#BFBFBF",
    "#7CFC00",
    "#CD1076",
    "#A4D3EE",
    "#7EC0EE",
    "#71C671",
    "#C71585",
    "#D02090",
    "#006400",
    "#EE9A49",
    "#4EEE94",
    "#0000EE",
    "#EE0000",
    "#8B7355",
    "#6495ED",
    "#7A8B8B",
    "#FFA54F",
    "#CD8C95",
    "#96CDCD",
    "#CDAA7D",
    "#F0FFF0",
    "#EE9A00",
    "#8B5742",
    "#40E0D0",
    "#5CACEE",
    "#D4D4D4",
    "#CD3700",
    "#FFE4C4",
    "#B9D3EE",
    "#DC143C",
    "#BC8F8F",
    "#8FBC8F",
    "#EEDC82",
    "#9FB6CD",
    "#4D4D4D",
    "#2F4F4F",
    "#EED5D2",
    "#7F7F7F",
    "#4A708B",
    "#030303",
    "#00CD66",
    "#CDC1C5",
    "#87CEEB",
    "#E9967A",
    "#BF3EFF",
    "#D9D9D9",
    "#0A0A0A",
    "#333333",
    "#7AC5CD",
    "#DA70D6",
    "#C5C1AA",
    "#EECBAD",
    "#B8B8B8",
    "#F5DEB3",
    "#90EE90",
    "#363636",
    "#CDB7B5",
    "#383838",
    "#4B0082",
    "#292421",
    "#EEA2AD",
    "#CD6889",
    "#1874CD",
    "#ED9121",
    "#FFDAB9",
    "#8B7E66",
    "#CDCDB4",
    "#483D8B",
    "#F7F7F7",
    "#B22222",
    "#CDB79E",
    "#5F9EA0",
    "#FFA07A",
    "#F08080",
    "#8E8E8E",
    "#C1C1C1",
    "#008B8B",
    "#EEC591",
    "#1E90FF",
    "#E0EEE0",
    "#FF69B4",
    "#EEEE00",
    "#828282",
    "#FFC0CB",
    "#CDBA96",
    "#FF8000",
    "#8E388E",
    "#8B4500",
    "#9C9C9C",
    "#CD6839",
    "#00FFFF",
    "#00F5FF",
    "#9C661F",
    "#98F5FF",
    "#CD9B1D",
    "#98FB98",
    "#7B68EE",
    "#6C7B8B",
    "#79CDCD",
    "#808A87",
    "#EE8262",
    "#836FFF",
    "#EED8AE",
    "#BDFCC9",
    "#262626",
    "#8B8970",
    "#8B8989",
    "#404040",
    "#BBFFFF",
    "#6B8E23",
    "#4F94CD",
    "#76EEC6",
    "#00868B",
    "#FFB90F",
    "#7A378B",
    "#FAEBD7",
    "#3D3D3D",
    "#5B5B5B",
    "#EEE9E9",
    "#FF3E96",
    "#8B8378",
    "#AEEEEE",
    "#050505",
    "#8B008B",
    "#B0E0E6",
    "#66CD00",
    "#E5E5E5",
    "#666666",
    "#000000",
    "#104E8B",
    "#00CDCD",
    "#424242",
    "#EEC900",
    "#CD6600",
    "#EED2EE",
    "#8B5A00",
    "#708090",
    "#008080",
    "#787878",
    "#00EE00",
    "#EEE9BF",
    "#8F8F8F",
    "#B3EE3A",
    "#1A1A1A",
    "#4682B4",
    "#FFB5C5",
    "#CD5555",
    "#A2CD5A",
    "#E3CF57",
    "#8B5F65",
    "#8B5A2B",
    "#1E1E1E",
    "#CAE1FF",
    "#00B2EE",
    "#BDB76B",
    "#CDC9A5",
    "#00EEEE",
    "#4F4F4F",
    "#FF7D40",
    "#A6A6A6",
    "#FFE1FF",
    "#C9C9C9",
    "#A2B5CD",
    "#698B22",
    "#EEE0E5",
    "#BABABA",
    "#8B4C39",
    "#878787",
    "#C1CDCD",
    "#2E2E2E",
    "#8B795E",
    "#FF8C69",
    "#F5F5DC",
    "#CD2990",
    "#8B2252",
    "#7FFF00",
    "#5C5C5C",
    "#8B8B7A",
    "#B4EEB4",
    "#C0C0C0",
    "#FDF5E6",
    "#FFEBCD",
    "#8B8386",
    "#FF4500",
    "#ADADAD",
    "#CD9B9B",
    "#FFE7BA",
    "#00008B",
    "#32CD32",
    "#8B4726",
    "#454545",
    "#FFBBFF",
    "#8A360F",
    "#ABABAB",
    "#616161",
    "#CD69C9",
    "#CDAF95",
    "#EEAEEE",
    "#EEAD0E",
    "#3A5FCD",
    "#ADFF2F",
    "#838B8B",
    "#595959",
    "#6959CD",
    "#EAEAEA",
    "#8B8B83",
    "#FF1493",
    "#8A3324",
    "#8B8878",
    "#CFCFCF",
    "#EEEEE0",
    "#CDC5BF",
    "#CDB38B",
    "#E3A869",
    "#080808",
    "#737373",
    "#CD7054",
    "#7A67EE",
    "#B8860B",
    "#E066FF",
    "#D1EEEE",
    "#F0FFFF",
    "#525252",
    "#528B8B",
    "#458B00",
    "#3CB371",
    "#3D9140",
    "#FAFAFA",
    "#B0E2FF",
    "#FF9912",
    "#D3D3D3",
    "#8B7765",
    "#87CEFF",
    "#CDCDC1",
    "#DCDCDC",
    "#8470FF",
    "#E3E3E3",
    "#F5FFFA",
    "#FF83FA",
    "#FF6A6A",
    "#8B636C",
    "#FF4040",
    "#800080",
    "#8B3E2F",
    "#8B3626",
    "#FFC1C1",
    "#EE9572",
    "#545454",
    "#CDC673",
    "#919191",
    "#5E5E5E",
    "#EE7AE9",
    "#CDAD00",
    "#BDBDBD",
    "#FCFCFC",
    "#EEE5DE",
    "#EEEED1",
    "#68838B",
    "#6E6E6E",
    "#CD96CD",
    "#B3B3B3",
    "#CDBE70",
    "#FF8247",
    "#C6E2FF",
    "#458B74",
    "#8968CD",
    "#E6E6FA",
    "#CDC9C9",
    "#FF7F00",
    "#9370DB",
    "#FF7F50",
    "#63B8FF",
    "#EE7942",
    "#696969",
    "#808080",
    "#CDCD00",
    "#6B6B6B",
    "#CD950C",
    "#436EEE",
    "#8B4513",
    "#999999",
    "#E0E0E0",
    "#7D9EC0",
    "#9AFF9A",
    "#4876FF",
    "#EE3A8C",
    "#97FFFF",
    "#FF8C00",
    "#EBEBEB",
    "#CD6090",
    "#0000CD",
    "#CD00CD",
    "#FF6EB4",
    "#A52A2A",
    "#00FA9A",
    "#20B2AA",
    "#EE6A50",
    "#141414",
    "#9B30FF",
    "#778899",
    "#228B22",
    "#808000",
    "#BFEFFF",
    "#EE7600",
    "#848484",
    "#9BCD9B",
    "#9E9E9E",
    "#9932CC",
    "#FF6103",
    "#ADD8E6",
    "#E8E8E8",
    "#303030",
    "#CD8500",
    "#5E2612",
    "#9F79EE",
    "#8B6508",
    "#8B1A1A",
    "#D15FEE",
    "#EECFA1",
    "#CD853F",
    "#FF82AB",
    "#CD4F39",
    "#CD919E",
    "#EE30A7",
    "#FAF0E6",
    "#8B7D6B",
    "#B5B5B5",
    "#2E8B57",
    "#474747",
    "#008B45",
    "#C0FF3E",
    "#FF7F24",
    "#EE799F",
    "#FAFAD2",
    "#76EE00",
    "#AB82FF",
    "#8B7500",
    "#B7B7B7",
    "#36648B",
    "#B0C4DE",
    "#1C1C1C",
    "#EEA9B8",
    "#D8BFD8",
    "#121212",
    "#8C8C8C",
    "#FF34B3",
    "#00C5CD",
    "#00FF7F",
    "#698B69",
    "#FFAEB9",
    "#A1A1A1",
    "#DAA520",
    "#0F0F0F",
    "#800000",
    "#CD0000",
    "#FCE6C9",
    "#8B475D",
    "#A8A8A8",
    "#171717",
    "#696969",
    "#FFDEAD",
    "#008B00",
    "#F5F5F5",
    "#EEB4B4",
    "#EE82EE",
    "#EE2C2C",
    "#EE7621",
    "#EEB422",
    "#8B668B",
    "#515151",
    "#48D1CC",
    "#CDB5CD",
    "#DBDBDB",
    "#EE1289",
    "#DEB887",
    "#7D26CD",
    "#6CA6CD",
    "#668B8B",
    "#3B3B3B",
    "#292929",
    "#8A8A8A",
    "#EDEDED",
    "#FF0000",
    "#CCCCCC",
    "#757575",
    "#F0F8FF",
    "#8B1C62",
    "#BCD2EE",
    "#CD8162",
    "#B0B0B0",
    "#8B2323",
    "#872657",
    "#636363",
    "#AAAAAA",
    "#548B54",
    "#8B2500",
    "#7171C6",
    "#8B0000",
    "#6A5ACD",
    "#912CEE",
    "#03A89E",
    "#C67171",
    "#575757",
    "#EE5C42",
    "#F4A460",
    "#FFD700",
    "#8B7D7B",
    "#C7C7C7"
];
export const mapStatisticTitles = {
    onTheWayDeliveryCount: {
        status: "Yolda",
        icon: "motorcycle",
        translation_key: "onTheWayDeliveryCount"
    },
    canceledDeliveryCount: {
        status: "İptal",
        icon: "remove",
        translation_key: "canceledDeliveryCount"
    },
    averageDeliveryTime: {
        status: "Ortalama Teslimat Süresi (dk)",
        icon: "chronometer",
        translation_key: "averageDeliveryTime"
    },
    orderPerDelivery: {
        status: "Sipariş Başına Paket Sayısı",
        icon: "shoppingCart",
        translation_key: "orderPerDelivery"
    },
    inQueueDeliveryCount: {
        status: "Kuyrukta",
        icon: "hourglass",
        translation_key: "inQueueDeliveryCount"
    },
    totalWaitingTimeInQueueAsMinutes: {
        status: "Kuyrukta geçen toplam süre (dk)",
        icon: "",
        translation_key: "totalWaitingTimeInQueueAsMinutes"
    },
    rejectedOrders: {status: "Karşılanamayan", icon: "list", translation_key: "rejectedOrders"},
    deliveredDeliveryCount: {
        status: "Teslim Edildi",
        icon: "tick",
        translation_key: "deliveredDeliveryCount"
    },
    totalWaitingTimeInQueueAsMinutesPercentage: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "totalWaitingTimeInQueueAsMinutesPercentage"
    },
    totalCanceledDeliveryInQueue: {
        status: "İptal",
        icon: "remove",
        translation_key: "totalCanceledDeliveryInQueue"
    },
    totalQueuedDeliveries: {
        status: "Toplam Kuyruğa Alınan",
        icon: "tick",
        translation_key: "totalQueuedDeliveries"
    },
    totalWaitTimePercentage: {
        status: "Ortalama Süre (dk)",
        icon: "hourglass",
        translation_key: "totalWaitTimePercentage"
    },
    averageOrderPerDelivery: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "averageOrderPerDelivery"
    },
    totalMergedDeliveries: {
        status: "Toplam Sipariş",
        icon: "tick",
        translation_key: "totalMergedDeliveries"
    },
    totalOrderCount: {status: "Toplam Paket", icon: "tick", translation_key: "totalOrderCount"},
    canceledInQueueDeliveryCount: {
        status: "İptal",
        icon: "remove",
        translation_key: "canceledInQueueDeliveryCount"
    },
    rejectedInQueueDeliveryCount: {
        status: "Karşılanamayan",
        icon: "list",
        translation_key: "rejectedInQueueDeliveryCount"
    },
    averageWaitingTimeInQueue: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "averageWaitingTimeInQueue"
    }
};

export const timeRangeOptionsStatistics = [
    {value: "daily", name: "Günlük", translation_key: "daily"},
    {value: "weekly", name: "Haftalık", translation_key: "weekly"},
    {value: "monthly", name: "Aylık", translation_key: "monthly"},
    {value: "", name: "Tüm Zamanlar", translation_key: "allTime"},
    {value: "choose", name: "Tarih Seç", translation_key: "choose"}
];

export const datePeriodOptions = [
    {value: "today", translation_key: "today"},
    {value: "tomorrow", translation_key: "tomorrow"},
    {value: "yesterday", translation_key: "yesterday"},
    {value: "", translation_key: "allTime"},
    {value: "choose", translation_key: "choose"}
];

export const paymentTypes = [
    {value: "paid", label: "Ödendi", translation_key: "paid"},
    {value: "creditCard", label: "Kredi Kartı", translation_key: "creditCard"},
    {value: "cash", label: "Nakit", translation_key: "cash"},
    {
        value: "ticketRestaurantCard",
        label: "Ticket Restaurant Yemek Kartı",
        translation_key: "ticketRestaurantCard"
    },
    {
        value: "ticketRestaurantVoucher",
        label: "Ticket Restaurant Yemek Çeki",
        translation_key: "ticketRestaurantVoucher"
    },
    {
        value: "sodexoRestaurantPass",
        label: "Sodexo Restaurant Pass",
        translation_key: "sodexoRestaurantPass"
    },
    {
        value: "sodexoRestaurantPassMobilePayment",
        label: "Sodexo Restaurant Pass Mobil Ödeme",
        translation_key: "sodexoRestaurantPassMobilePayment"
    },
    {
        value: "sodexoOnline",
        label: "Sodexo Online",
        translation_key: "sodexoOnline"
    },
    {
        value: "sodexoCard",
        label: "Sodexo Kart",
        translation_key: "sodexoCard"
    },
    {value: "multinet", label: "Multinet", translation_key: "multinet"},
    {value: "setCard", label: "SetCard", translation_key: "setCard"},
    {
        value: "yemekmatikYemekKart",
        label: "Yemekmatik Yemek Kartı",
        translation_key: "yemekmatikYemekKart"
    },
    {value: "metropolCard", label: "MetropolCard", translation_key: "metropolCard"},
    {value: "cioCard", label: "CIO Card", translation_key: "cioCard"},
    {value: "payeCard", label: "Paye Kart", translation_key: "payeCard"},
    {value: "winWin", label: "WinWin", translation_key: "winWin"},
    {value: "tokenFlex", label: "TokenFlex", translation_key: "tokenFlex"}
];

export const defaultSlotCourierIds = [
    "60818a5a25188ebd24133624", // prod
    "62c2b5b6834037072e2b95e5", // sandbox
    "60928a5e1cc4462450c6d478" // dev
];

export const shiftReportStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "inReview", name: "Askıya Alındı", translation_key: "inReview"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "needFillPackage", name: "Paket Bekleniyor", translation_key: "needFillPackage"}
];

export const objectionStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "declined", name: "Reddedildi", translation_key: "declined"}
];

export const dayOffStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "rejected", name: "Reddedildi", translation_key: "rejected"}
];
export const lastRespondedByStatuses = [
    {value: "company", name: "En Son Firma Yanıtlamış", translation_key: "company"},
    {value: "authorized", name: "En Son Vigo Yanıtlamış", translation_key: "authorized"}
];

export const hours = [
    {value: 0, name: "00:00"},
    {value: 1, name: "01:00"},
    {value: 2, name: "02:00"},
    {value: 3, name: "03:00"},
    {value: 4, name: "04:00"},
    {value: 5, name: "05:00"},
    {value: 6, name: "06:00"},
    {value: 7, name: "07:00"},
    {value: 8, name: "08:00"},
    {value: 9, name: "09:00"},
    {value: 10, name: "10:00"},
    {value: 11, name: "11:00"},
    {value: 12, name: "12:00"},
    {value: 13, name: "13:00"},
    {value: 14, name: "14:00"},
    {value: 15, name: "15:00"},
    {value: 16, name: "16:00"},
    {value: 17, name: "17:00"},
    {value: 18, name: "18:00"},
    {value: 19, name: "19:00"},
    {value: 20, name: "20:00"},
    {value: 21, name: "21:00"},
    {value: 22, name: "22:00"},
    {value: 23, name: "23:00"},
    {value: 24, name: "24:00"}
];

export const resolutionOptions = [
    {
        value: 12,
        label: "Nano Alan - 12.Seviye",
        description: "~0.01km genişliğinde alanlar",
        size: "~0.01km"
    },
    {
        value: 11,
        label: "Mikro Alan - 11.Seviye",
        description: "~0.05km genişliğinde alanlar",
        size: "~0.05km"
    },
    {
        value: 10,
        label: "Mini Alan - 10.Seviye",
        description: "~0.10km genişliğinde alanlar",
        size: "~0.10km"
    },
    {
        value: 9,
        label: "Ultra Mikro Alan - 9.Seviye",
        description: "~0.20km genişliğinde alanlar",
        size: "~0.20km"
    },
    {
        value: 8,
        label: "Mikro Alan - 8.Seviye",
        description: "~0.53km genişliğinde alanlar",
        size: "~0.53km"
    },
    {
        value: 7,
        label: "Çok Dar Alan - 7.Seviye",
        description: "~1.41km genişliğinde alanlar",
        size: "~1.41km"
    },
    {
        value: 6,
        label: "Dar Alan - 6.Seviye",
        description: "~3.72km genişliğinde alanlar",
        size: "~3.72km"
    },
    {
        value: 5,
        label: "Orta Alan - 5.Seviye",
        description: "~9.85km genişliğinde alanlar",
        size: "~9.85km"
    },
    {
        value: 4,
        label: "Orta-Geniş Alan - 4.Seviye",
        description: "~26km genişliğinde alanlar",
        size: "~26km"
    },
    {
        value: 3,
        label: "Geniş Alan - 3.Seviye",
        description: "~69km genişliğinde alanlar",
        size: "~69km"
    },
    {
        value: 2,
        label: "Çok Geniş Alan - 2.Seviye",
        description: "~182.5km genişliğinde alanlar",
        size: "~182.5km"
    },
    {
        value: 1,
        label: "Ultra Geniş Alan - 1.Seviye",
        description: "~483km genişliğinde alanlar",
        size: "~483km"
    }
];

export const codPaymentSubcompanyPaymentPeriods = [
    {value: "weekly", name: "Haftalık", translation_key: "weekly"},
    {value: "monthly", name: "Aylık", translation_key: "monthly"}
];

export const SubCompanyOnboardingStatuses = [
    {value: "candidate", name: "Aday", translation_key: "candidate"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "rejected", name: "Reddedildi", translation_key: "rejected"},
    {value: "pending", name: "Beklemede", translation_key: "pending"}
];

export const creditLogTransactionTypes = Object.freeze({
    LOAD: "LOAD",
    USE: "USE",
    OBJECTION: "OBJECTION",
    CASH: "CASH",
    CAMPAIGN: "CAMPAIGN",
    PENALTY: "PENALTY",
    DEDICATED_SHIFT: "DEDICATED_SHIFT",
    ADJUSTMENT: "ADJUSTMENT",
    EQUIPMENT: "EQUIPMENT",
    HEALTH_INSURANCE: "HEALTH_INSURANCE",
    BONUS: "BONUS",
    WALLET_RESET: "WALLET_RESET",
    EXCEL_IMPORT: "EXCEL_IMPORT"
});

export const creditLogTransactionTypeOptions = [
    {value: creditLogTransactionTypes.LOAD, label: "Yükleme", color: "#009e0f", textColor: "white"},
    {value: creditLogTransactionTypes.USE, label: "Harcama", color: "#dc2626", textColor: "white"},
    {
        value: creditLogTransactionTypes.OBJECTION,
        label: "İtiraz",
        color: "#990000",
        textColor: "white"
    },
    {value: creditLogTransactionTypes.CASH, label: "Nakit Tahsilat"},
    {value: creditLogTransactionTypes.CAMPAIGN, label: "Kampanya"},
    {value: creditLogTransactionTypes.PENALTY, label: "Ceza", color: "#cccccc", textColor: "black"},
    {
        value: creditLogTransactionTypes.DEDICATED_SHIFT,
        label: "Dedike Vardiya",
        color: "#9fc5f8",
        textColor: "black"
    },
    {
        value: creditLogTransactionTypes.ADJUSTMENT,
        label: "Eklenti & Kesinti",
        color: "#ffe599",
        textColor: "black"
    },
    {
        value: creditLogTransactionTypes.EQUIPMENT,
        label: "Ekipman",
        color: "#f9cb9c",
        textColor: "black"
    },
    {
        value: creditLogTransactionTypes.HEALTH_INSURANCE,
        label: "Sağlık Sigortası",
        color: "#274e13",
        textColor: "white"
    },
    {value: creditLogTransactionTypes.BONUS, label: "Bonus", color: "#6aa84f", textColor: "white"},
    {
        value: creditLogTransactionTypes.WALLET_RESET,
        label: "Cüzdan Sıfırlama",
        color: "#c27ba0",
        textColor: "white"
    },
    {
        value: creditLogTransactionTypes.EXCEL_IMPORT,
        label: "Excel İçe Aktarma",
        color: "#666666",
        textColor: "white"
    }
];

export const creditLogSubTypes = Object.freeze({
    PAYMENT: "PAYMENT",
    SAATLIK_UCRET_KESINTISI: "SAATLIK_UCRET_KESINTISI",
    KM: "KM",
    PAKET: "PAKET",
    HOURLY_FEE: "hourlyFee",
    HOURLY_GUARANTEE_FEE: "hourlyGuaranteeFee",
    PACKAGE_BONUS_FEE: "packageBonusFee",
    SAATLIK_UCRET: "SAATLIK_UCRET",
    YARIM_PAKET: "YARIM_PAKET",
    IPTAL_PAKET: "IPTAL_PAKET",
    BONUS_PAKET_KAZANCI_UCRETI: "BONUS_PAKET_KAZANCI_UCRETI",
    KAZANDIRAN_PAKET_KAZANCI: "KAZANDIRAN_PAKET_KAZANCI",
    UYUM_SAATLIK_UCRET: "UYUM_SAATLIK_UCRET",
    SAATLIK_GARANTI_PAKET: "SAATLIK_GARANTI_PAKET",
    CASH: "CASH",
    REFUND: "REFUND",
    OBJECTION: "OBJECTION",
    SHIFT_EDIT: "SHIFT_EDIT",
    PENALTY: "PENALTY",
    EQUIPMENT: "EQUIPMENT",
    HEALTH_INSURANCE: "HEALTH_INSURANCE",
    BONUS: "BONUS",
    WALLET_RESET: "WALLET_RESET",
    PAYCUT: "PAYCUT",
    ADDITION: "ADDITION",
    EKSTRA: "EKSTRA"
});

export const creditLogSubTypeOptions = [
    {value: creditLogSubTypes.PAYMENT, label: "Bakiye Yükleme"},
    {value: creditLogSubTypes.SAATLIK_UCRET_KESINTISI, label: "Saatlik Ücret Kesintisi"},
    {value: creditLogSubTypes.KM, label: "Mesafe"},
    {value: creditLogSubTypes.PAKET, label: "Paket"},
    {value: creditLogSubTypes.HOURLY_FEE, label: "Saatlik Ücret"},
    {value: creditLogSubTypes.HOURLY_GUARANTEE_FEE, label: "Saatlik Garanti Paket"},
    {value: creditLogSubTypes.PACKAGE_BONUS_FEE, label: "Bonus Paket Kazanç"},
    {value: creditLogSubTypes.SAATLIK_UCRET, label: "Saatlik Ücret"},
    {value: creditLogSubTypes.YARIM_PAKET, label: "Yarım Paket"},
    {value: creditLogSubTypes.IPTAL_PAKET, label: "İptal Paket"},
    {value: creditLogSubTypes.BONUS_PAKET_KAZANCI_UCRETI, label: "Bonus Paket Kazanç Ücreti"},
    {value: creditLogSubTypes.KAZANDIRAN_PAKET_KAZANCI, label: "Kazandıran Paket Kazancı"},
    {value: creditLogSubTypes.UYUM_SAATLIK_UCRET, label: "Uyum Saatlik Ücret"},
    {value: creditLogSubTypes.SAATLIK_GARANTI_PAKET, label: "Saatlik Paket Garanti"},
    {value: creditLogSubTypes.CASH, label: "Nakit Tahsilat"},
    {value: creditLogSubTypes.REFUND, label: "İade"},
    {value: creditLogSubTypes.OBJECTION, label: "İtiraz"},
    {value: creditLogSubTypes.SHIFT_EDIT, label: "Vardiya Düzeltme"},
    {value: creditLogSubTypes.PENALTY, label: "Ceza"},
    {value: creditLogSubTypes.EQUIPMENT, label: "Ekipman"},
    {value: creditLogSubTypes.HEALTH_INSURANCE, label: "Sağlık Sigortası"},
    {value: creditLogSubTypes.BONUS, label: "Bonus"},
    {value: creditLogSubTypes.WALLET_RESET, label: "Cüzdan Sıfırlama"},
    {value: creditLogSubTypes.PAYCUT, label: "Kesinti"},
    {value: creditLogSubTypes.ADDITION, label: "Eklenti"},
    {value: creditLogSubTypes.EKSTRA, label: "Ekstra"}
];
export const creditModeLabels = {
    active: "Kredili",
    onlyLog: "Kredisiz Entegre",
    passive: "Kredisiz"
};

export const getCreditModeLabel = value => creditModeLabels[value] || value;

// Kredili çalışan alt firmalar fatura dönemine tabi değil
export const invoicePeriodDisabledCreditModes = ["active"];
export const isInvoicePeriodDisabled = creditMode =>
    invoicePeriodDisabledCreditModes.includes(creditMode);

export const invoicePeriodRequiredCreditModes = ["onlyLog", "passive"];
export const isInvoicePeriodRequired = creditMode =>
    invoicePeriodRequiredCreditModes.includes(creditMode);

export const creditLogsObjectionTypes = [
    {
        value: "missingPayment",
        label: "Firmamdan Eksik Ödeme Alındı",
        translation_key: "missingPayment"
    },
    {
        value: "overPayment",
        label: "Firmamdan Fazla Ödeme Alındı",
        translation_key: "overPayment"
    }
];

export const creditLogObjectionApprovalTypesForCourier = [
    {
        value: "deductFromCourierEarnings",
        label: "Hakedişten Düş",
        translation_key: "deductFromCourierEarnings"
    },
    {
        value: "addToCourierEarnings",
        label: "Hakedişe Ekle",
        translation_key: "addToCourierEarnings"
    },
    {
        value: "none",
        label: "İşlem Yapma",
        translation_key: "none"
    }
];

export const creditLogObjectionApprovalTypesForCompany = [
    {
        value: "deductFromCompanyCredit",
        label: "Krediden Düş",
        translation_key: "deductFromCompanyCredit"
    },
    {
        value: "addToCompanyCredit",
        label: "Krediye Ekle",
        translation_key: "addToCompanyCredit"
    },
    {
        value: "none",
        label: "İşlem Yapma",
        translation_key: "none"
    }
];

export const codPaymentStatuses = [
    {value: "PENDING", name: "Ödeme Bekliyor", translation_key: "PENDING"},
    {value: "SUCCESS", name: "Ödeme Alındı", translation_key: "SUCCESS"}, //Ödeme Başarılı
    {value: "ORDER_CANCEL", name: "Sipariş İptal", translation_key: "ORDER_CANCEL"},
    {value: "FAILED", name: "Ödeme Başarısız", translation_key: "FAILED"},
    {value: "CANCELLED", name: "Ödeme İptal", translation_key: "CANCELLED"},
    {value: "BANK_VERIFIED", name: "Para Hesaba Geçti", translation_key: "BANK_VERIFIED"}, //"Banka Onaylandı",
    {
        value: "WAITING_MERCHANT_INVOICE",
        name: "Müşteri Faturası Bekleniyor",
        translation_key: "WAITING_MERCHANT_INVOICE"
    },
    {value: "WAITING_PAYOUT", name: "Geri Ödeme Bekliyor", translation_key: "WAITING_PAYOUT"},
    {
        value: "WAITING_PAYOUT_APPROVED",
        name: "Geri Ödeme Onaylandı",
        translation_key: "WAITING_PAYOUT_APPROVED"
    },
    {value: "PAID", name: "Ödendi", translation_key: "PAID"}
];

export const codPaymentApproveStatuses = [
    {value: "PENDING", name: "Onay Bekliyor", translation_key: "PENDING"},
    {value: "APPROVED", name: "Onaylandı", translation_key: "APPROVED"},
    {value: "FRAUD", name: "Fraud İşaretlendi", translation_key: "FRAUD"}
];

export const codPaymentReferenceCodeStatuses = [
    {value: "PENDING", name: "Fatura Bekleniyor", translation_key: "PENDING", color: "#ff0000"},
    {
        value: "INVOICE_CREATED",
        name: "Fatura Kesildi",
        translation_key: "INVOICE_CREATED",
        color: "#ffc103"
    },
    {
        value: "PAYMENT_IN_PROGRESS",
        name: "Ödeme Devam Ediyor",
        translation_key: "PAYMENT_IN_PROGRESS",
        color: "#ffc103"
    },
    {value: "PAID", name: "Geri Ödemesi Alındı", translation_key: "PAID", color: "#8ed973"},
    {value: "FAILED", name: "Bankadan Döndü", translation_key: "FAILED", color: "#ff0000"}
];

export const courierBonusCampaignStatuses = {
    ACTIVE: {
        value: "active",
        label: "Aktif",
        translation_key: "active"
    },
    INACTIVE: {
        value: "inactive",
        label: "Pasif",
        translation_key: "inactive"
    }
};

export const courierBonusCampaignTypes = {
    HOURLY_FEE: {
        value: "hourlyFee",
        label: "Saatlik Kazanç",
        translation_key: "hourlyFee"
    },
    PACKAGE_BONUS_FEE: {
        value: "packageBonusFee",
        label: "Bonus Paket Kazancı",
        translation_key: "packageBonusFee"
    },
    HOURLY_GUARANTEE_FEE: {
        value: "hourlyGuaranteeFee",
        label: "Saatlik Garanti Kazanç",
        translation_key: "hourlyGuaranteeFee"
    }
};

export const guaranteeCalculationFactors = {
    PACKAGE_AMOUNT: {
        value: "packageAmount",
        label: "Paket Miktarı",
        translation_key: "packageAmount"
    },
    KM_AMOUNT: {
        value: "kmAmount",
        label: "Km Miktarı",
        translation_key: "kmAmount"
    },
    BONUS_PACKAGE_AMOUNT: {
        value: "bonusPackageAmount",
        label: "Bonus Paket Kazancı",
        translation_key: "bonusPackageAmount"
    },
    BONUS_HOUR_AMOUNT: {
        value: "bonusHourAmount",
        label: "Bonus Saat Kazancı",
        translation_key: "bonusHourAmount"
    }
};

export const daysList = [
    {value: 1, name: "Pazartesi", translation_key: "monday"},
    {value: 2, name: "Salı", translation_key: "tuesday"},
    {value: 3, name: "Çarşamba", translation_key: "wednesday"},
    {value: 4, name: "Perşembe", translation_key: "thursday"},
    {value: 5, name: "Cuma", translation_key: "friday"},
    {value: 6, name: "Cumartesi", translation_key: "saturday"},
    {value: 7, name: "Pazar", translation_key: "sunday"}
];

export const daysList2 = [
    {value: 1, name: "Pzt", translation_key: "monday"},
    {value: 2, name: "Sa", translation_key: "tuesday"},
    {value: 3, name: "Çrş", translation_key: "wednesday"},
    {value: 4, name: "Prş", translation_key: "thursday"},
    {value: 5, name: "Cu", translation_key: "friday"},
    {value: 6, name: "Cum", translation_key: "saturday"},
    {value: 0, name: "Paz", translation_key: "sunday"}
];

export const codPaymentTypes = [
    {
        value: "cash",
        label: "Nakit",
        translation_key: "cash"
    },
    {
        value: "creditCard",
        label: "Kredi Kartı",
        translation_key: "creditCard"
    },
    {
        value: "mealCard",
        label: "Yemek Kartı",
        translation_key: "mealCard"
    }
];

export const codPaymentTransactionProviderPaymentStatuses = [
    {value: "PENDING", name: "Bekliyor", translation_key: "PENDING"},
    {value: "PAID", name: "Ödendi", translation_key: "PAID"},
    {value: "CANCEL", name: "İptal", translation_key: "CANCEL"},
    {value: "SUCCESS", name: "Başarılı", translation_key: "SUCCESS"},
    {value: "NOT_SUCCESS", name: "Başarısız", translation_key: "NOT_SUCCESS"},
    {value: "WAITING", name: "Bekliyor", translation_key: "WAITING"},
    {value: "FAIL", name: "Başarısız", translation_key: "FAIL"}
];

// Kurye arama durumları enum'u
export const courierCallStatusMap = {
    notCalled: "Aranmadı",
    called: "Arandı",
    willCallAgain: "Tekrar Aranacak",
    reached: "Ulaşıldı",
    unreachable: "Ulaşılamadı",
    approve: "Olumlu",
    deny: "Olumsuz",
    blocked: "Kara Liste",
    wrongPhoneNumber: "Hatalı Telefon"
};
export const experienceTypes = Object.freeze({
    none: {tr: "Yok", en: "No Experience"},
    "m0-6": {tr: "0-6 Ay", en: "0-6 Months"},
    "m6-12": {tr: "6-12 Ay", en: "6-12 Months"},
    "m12+": {tr: "12 Ay ve Üzeri", en: "12 Months and Over"},
    "m12-24": {tr: "12-24 Ay", en: "12-24 Months"},
    "m24+": {tr: "24 Ay ve üzeri", en: "24 Months and over"},
    "y0-2": {tr: "0-2 Yıl", en: "0-2 Years"},
    "y2-4": {tr: "2-4 Yıl", en: "2-4 Years"},
    "y4-6": {tr: "4-6 Yıl", en: "4-6 Years"},
    "y6+": {tr: "+6 Yıl", en: "+6 Years"}
});

export const deviceOSEnum = Object.freeze({
    IOS: "iOS",
    ANDROID: "Android"
});

export const iOSDeviceModelIdentifiers = Object.freeze({
    "iPhone10,2": "iPhone 8 Plus",
    "iPhone10,3": "iPhone X",
    "iPhone10,4": "iPhone 8 (no CDMA)",
    "iPhone10,5": "iPhone 8 Plus (no CDMA)",
    "iPhone10,6": "iPhone X (no CDMA)",
    "iPhone11,2": "iPhone XS",
    "iPhone11,4": "iPhone XS Max (China)",
    "iPhone11,6": "iPhone XS Max",
    "iPhone11,8": "iPhone XR",
    "iPhone12,1": "iPhone 11",
    "iPhone12,3": "iPhone 11 Pro",
    "iPhone12,5": "iPhone 11 Pro Max",
    "iPhone12,8": "iPhone SE 2nd Gen",
    "iPhone13,1": "iPhone 12 mini",
    "iPhone13,2": "iPhone 12",
    "iPhone13,3": "iPhone 12 Pro",
    "iPhone13,4": "iPhone 12 Pro Max",
    "iPhone14,2": "iPhone 13 Pro",
    "iPhone14,3": "iPhone 13 Pro Max",
    "iPhone14,4": "iPhone 13 mini",
    "iPhone14,5": "iPhone 13",
    "iPhone14,6": "iPhone SE 3rd Gen",
    "iPhone14,7": "iPhone 14",
    "iPhone14,8": "iPhone 14 Plus",
    "iPhone15,2": "iPhone 14 Pro",
    "iPhone15,3": "iPhone 14 Pro Max",
    "iPhone15,4": "iPhone 15",
    "iPhone15,5": "iPhone 15 Plus",
    "iPhone16,1": "iPhone 15 Pro",
    "iPhone16,2": "iPhone 15 Pro Max",
    "iPhone17,1": "iPhone 16 Pro",
    "iPhone17,2": "iPhone 16 Pro Max",
    "iPhone17,3": "iPhone 16",
    "iPhone17,4": "iPhone 16 Plus",
    "iPhone17,5": "iPhone 16e"
});

export const androidDeviceModelIdentifiers = Object.freeze({
    "23117RA68G": "Redmi Note 13 Pro",
    "2201116TG": "Redmi Note 11",
    "2209116AG": "Redmi Note 11S",
    "23124RA7EO": "Xiaomi Redmi Note 13",
    "2312DRA50G": "Xiaomi Redmi Note 13 5G",
    "22101316G": "Redmi Note 12",
    "SM-A245F": "Samsung Galaxy A24",
    "23090RA98G": "Redmi 12",
    "SM-A346E": "Samsung Galaxy A34",
    "23053RN02A": "Redmi Note 12 4G",
    "SM-A546E": "Samsung Galaxy A54",
    "24040RN64Y": "Redmi Note 13 4G",
    M2101K6G: "Redmi Note 10 Pro",
    "SM-A325F": "Samsung Galaxy A32",
    "SM-A165F": "Samsung Galaxy A16",
    "SM-A155F": "Samsung Galaxy A15",
    "SM-A556E": "Samsung Galaxy A55"
});

export const TWENTY_SECONDS_IN_MS = 20 * 1000;
export const TWO_SECONDS_IN_MS = 2 * 1000;

// Platform Integration Colors
export const PLATFORM_COLORS = {
    SIMPRA: "#FFD700", // Sarı
    YEMEKSEPETI: "#E91E63", // Koyu pembe
    BOYNER: "#FF1493", // Kırmızı pembe karışımı
    HEPSIEXPRESS: "#FF8C00", // Turuncu
    TICIMAX: "#1E3A8A", // Koyu mavi
    TRENDYOLYEMEK: "#FF8C00", // Turuncu
    GETIRYEMEK: "#8B5CF6", // Mor
    GETIRCARSI: "#8B5CF6", // Mor
    DEFAULT: "#AEF001" // Varsayılan yeşil
};
// Platform Gradient Backgrounds
export const PLATFORM_GRADIENTS = {
    SIMPRA: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)", // Altın gradyan
    YEMEKSEPETI: "linear-gradient(135deg, #E91E63 0%, #C2185B 100%)", // Pembe gradyan
    BOYNER: "linear-gradient(135deg, #FF1493 0%, #E91E63 100%)", // Kırmızı pembe gradyan
    HEPSIEXPRESS: "linear-gradient(135deg, #FF8C00 0%, #FF6B35 100%)", // Turuncu gradyan
    TICIMAX: "linear-gradient(135deg, #1E3A8A 0%, #3B82F6 100%)", // Mavi gradyan
    TRENDYOLYEMEK: "linear-gradient(135deg, #FF8C00 0%, #FF6B35 100%)", // Turuncu gradyan
    GETIRYEMEK: "linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%)", // Mor gradyan
    GETIRCARSI: "linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%)", // Mor gradyan
    DEFAULT: "linear-gradient(135deg, #AEF001 0%, #8BC34A 100%)" // Yeşil gradyan
};

//Platform Names
export const PLATFORM_NAMES = {
    simpra: "Simpra",
    yemekSepeti: "Yemeksepeti",
    boyner: "Boyner",
    hepsiExpress: "HepsiExpress",
    ticimax: "Ticimax",
    trendyolYemek: "Trendyol Yemek",
    getirYemek: "GetirYemek",
    getirCarsi: "GetirÇarşı"
};

export const courierRequestPriorityEnums = {
    URGENT: "urgent", // Acil öncelikli
    HIGH: "high", // Yüksek öncelikli
    NORMAL: "normal" // Normal öncelikli
};
export const courierRequestPriorities = [
    {value: courierRequestPriorityEnums.URGENT, name: "Acil Öncelikli"},
    {value: courierRequestPriorityEnums.HIGH, name: "Yüksek Öncelikli"},
    {value: courierRequestPriorityEnums.NORMAL, name: "Normal Öncelikli"}
];
export const courierRequestPriorityRankIconKeys = {
    [courierRequestPriorityEnums.URGENT]: "urgent",
    [courierRequestPriorityEnums.HIGH]: "high",
    [courierRequestPriorityEnums.NORMAL]: "medium"
};

export const courierRequestStatusEnums = Object.freeze({
    NEW_REQUEST: "newRequest", // Yeni talep
    IN_PROGRESS: "inProgress", // Devam ediyor
    CLOSED: "closed", // Kapatıldı
    COMPLETED: "completed" // Tamamlandı
});

export const courierRequestStatuses = [
    {value: courierRequestStatusEnums.NEW_REQUEST, name: "Yeni Talep", color: "blue"},
    {value: courierRequestStatusEnums.IN_PROGRESS, name: "Devam Ediyor", color: "orange"},
    {value: courierRequestStatusEnums.CLOSED, name: "Kapatıldı", color: "red"},
    {value: courierRequestStatusEnums.COMPLETED, name: "Tamamlandı", color: "green"}
];

export const courierRequestCourierApprovalStatues = {
    APPROVED: "approved",
    MISSING_DOCUMENTS: "missingDocument"
};

export const courierRequestCourierApprovalStatuses = [
    {value: courierRequestCourierApprovalStatues.APPROVED, name: "Onaylı"},
    {
        value: courierRequestCourierApprovalStatues.MISSING_DOCUMENTS,
        name: "Eksik Belge"
    }
];

// Shift Request Status Enums
export const shiftRequestStatusEnums = Object.freeze({
    ALL: "all",
    WAITING: "waiting",
    PENDING_APPROVAL: "pending_approval",
    RECRUITMENT_IN_PROGRESS: "recruitment_in_progress",
    RECRUITMENT_COMPLETED: "recruitment_completed",
    COMPLETED: "completed",
    REJECTED: "rejected",
    CANCELLED: "cancelled"
});

// Shift Request Statuses
export const shiftRequestStatuses = [
    {value: shiftRequestStatusEnums.ALL, label: "Tümü", color: "#1890ff"},
    {value: shiftRequestStatusEnums.WAITING, label: "Beklemede", color: "#808080"},
    {value: shiftRequestStatusEnums.PENDING_APPROVAL, label: "Onay Bekliyor", color: "#faad14"},
    {
        value: shiftRequestStatusEnums.RECRUITMENT_IN_PROGRESS,
        label: "Kurye tedarik aşamasında",
        color: "#1890ff"
    },
    {
        value: shiftRequestStatusEnums.RECRUITMENT_COMPLETED,
        label: "Kurye tedarik edildi, işbaşı bekleniyor",
        color: "#0097a7"
    },
    {value: shiftRequestStatusEnums.COMPLETED, label: "Talep tamamlandı", color: "#52c41a"},
    {value: shiftRequestStatusEnums.REJECTED, label: "Reddedildi", color: "#e53935"},
    {value: shiftRequestStatusEnums.CANCELLED, label: "İptal Edildi", color: "#660000"}
];

// Shift Request Approval Flow
export const shiftRequestApprovalFlow = [
    {
        index: 1,
        roles: ["sales"],
        updatableStatus: ["PENDING_APPROVAL"]
    },
    {
        index: 2,
        roles: ["bm", "sy", "agency"],
        updatableStatus: ["RECRUITMENT_IN_PROGRESS"]
    },
    {
        index: 3,
        roles: ["ik"],
        updatableStatus: ["RECRUITMENT_COMPLETED"]
    },
    {
        index: 4,
        roles: ["bm", "sy", "agency"],
        updatableStatus: ["COMPLETED"]
    }
];

// Pending Unit Types
export const currentApprovalRoles = [
    {value: "all", label: "Tümü"},
    {value: "bm", label: "Bölge Müdürü (BM)"},
    {value: "sy", label: "Saha Yöneticisi (SY)"},
    {value: "agency", label: "Acente"},
    {value: "ik", label: "İşe Alım"},
    {value: "sales", label: "Satış"},
    {value: "admin", label: "Admin"}
];

// Shift Request Types
export const shiftRequestTypes = [
    {value: "all", label: "Tümü"},
    {value: "decrement", label: "Kurye Azaltma"},
    {value: "increment", label: "Kurye Artırma"},
    {value: "support", label: "Destek"}
];

export const personalCompanySetupStatusEnums = Object.freeze({
    NOT_ANSWERED: "notAnswered",
    SELF_SETUP_SELECTED: "selfSetupSelected",
    SUPPORT_REQUESTED: "supportRequested",
    COMPLETED: "completed"
});

export const personalCompanySetupStatuses = [
    {
        value: personalCompanySetupStatusEnums.NOT_ANSWERED,
        name: "Cevaplanmamış",
        color: "default"
    },
    {
        value: personalCompanySetupStatusEnums.SELF_SETUP_SELECTED,
        name: "Kendi Kuracak",
        color: "blue"
    },
    {
        value: personalCompanySetupStatusEnums.SUPPORT_REQUESTED,
        name: "Destek Bekleniyor",
        color: "orange"
    },
    {
        value: personalCompanySetupStatusEnums.COMPLETED,
        name: "Tamamlandı",
        color: "green"
    }
];
export const projectTypesEnum = [
    {value: 1, label: "Havuz", translation_key: "pool"},
    {value: 2, label: "Dedike", translation_key: "dedicated"}
];

export const VIGO_PANEL_LOGO =
    "https://vigo-software.s3.eu-west-1.amazonaws.com/vigo-backoffice/text-logo.svg";
export const V_LOGO = "https://vigo-software.s3.eu-west-1.amazonaws.com/vigo-backoffice/v-logo.svg";

export const oneSignalNotificationTypes = [
    {value: "newOrder", label: "Yeni Sipariş"},
    {value: "mergeOrder", label: "Sipariş Birleştirme"},
    {value: "transferOrder", label: "Sipariş Transfer"},
    {value: "completeTransfer", label: "Transfer Tamamlandı"},
    {value: "cancelDelivery", label: "Teslimat İptal"},
    {value: "cancelOrder", label: "Sipariş İptal"},
    {value: "passOrder", label: "Sipariş Pas Geçildi"},
    {value: "splitOrder", label: "Sipariş Bölündü"},
    {value: "forceOrder", label: "Zorunlu Sipariş"},
    {value: "forceOrderCanceled", label: "Zorunlu Sipariş İptal"},
    {value: "cancelTransferedOrder", label: "Transfer Edilmiş Sipariş İptal"},
    {value: "courierStatusUpdate", label: "Kurye Durum Güncelleme"},
    {value: "testNotification", label: "Test Bildirimi"},
    {value: "shiftSuggestionNotification", label: "Vardiya Bildirimi"},
    {value: "remindShiftPreferenceNotification", label: "Vardiya Hatırlatma"},
    {value: "approveNotification", label: "Onay Bildirimi"},
    {value: "remindShiftNotification", label: "Vardiya Başlama Hatırlatma"},
    {value: "warnShiftNotification", label: "Vardiya Uyarı"},
    {value: "rejectNotification", label: "Red Bildirimi"},
    {value: "remindPackageCount", label: "Paket Sayısı Hatırlatma"},
    {value: "courierOnboardingDocumentsApproved", label: "İşe Alım Belge Onayı"},
    {value: "courierOnboardingDocumentsRejected", label: "İşe Alım Belge Reddi"},
    {value: "courierOnboardingComplete", label: "İşe Alım Tamamlandı"},
    {value: "breakStarted", label: "Mola Başladı"},
    {value: "breakEnded", label: "Mola Bitti"},
    {value: "breakOrderCanceled", label: "Mola İptal"},
    {value: "announcement", label: "Duyuru"},
    {value: "paymentPeriodProcessed", label: "Cüzdan İşlemi Bildirimi"}
];

export const projectInfoOptions = [
    {value: "V+", name: "V+"},
    {value: "Getir", name: "Getir"},
    {value: "Havuz", name: "Havuz"}
];

export const managerCompanyOptions = [
    {value: "vigo", name: "Vigo"},
    {value: "agency", name: "Acente"}
];

export const MANAGER_COMPANY_UNSET = "unset";

export const DELIVERY_STATUS_ITEMS = [
    {key: "errored", label: "Hata", color: "#cf1322", background: "#fff1f0"},
    {key: "failed", label: "Başarısız", color: "#cf1322", background: "#fff1f0"},
    {key: "successful", label: "Başarılı", color: "#237804", background: "#f6ffed"},
    {key: "received", label: "Alınan", color: "#0958d9", background: "#e6f4ff"}
];

export const DETAIL_TABLE_SUB_TYPE_LABELS = {
    KM: "KM",
    PAKET: "Paket",
    SAATLIK_UCRET: "Saatlik Ücret",
    SAATLIK_GARANTI_PAKET: "Saatlik Garanti Paket",
    PAKET_BONUSU: "Paket Bonusu",
    EKLENTI: "Eklenti",
    REFUND: "İade",
    OBJECTION: "İtiraz",
    PAYCUT: "Kesinti",
    CASH: "Nakit Tahsilat",
    SHIFT_EDIT: "Vardiya Düzeltme",
    WITHOLDING: "Tevkifat",
    BONUS_PAKET_KAZANCI_UCRETI: "Bonus Paket Kazancı Ücreti",
    hourlyGuaranteeFee: "Saatlik Garanti Ücret",
    hourlyFee: "Saatlik Ücret",
    packageBonusFee: "Paket Bonusu Ücreti"
};

export const invoiceStatuses = [
    {value: "waitingForCourierInvoice", name: "Fatura Oluşturulması Bekleniyor"},
    {value: "created", name: "Oluşturuldu"},
    {value: "completed", name: "Tamamlandı"},
    {value: "processing", name: "İşleniyor"},
    {value: "failed", name: "Başarısız"},
    {value: "canceled", name: "İptal Edildi"},
    {value: "none", name: "Fatura Yok"}
];

export const CUSTOMER_SHIFTS_TABS = {
    ACTIVE: "activeShifts",
    PLANNED: "futureShifts",
    COMPLETED: "pastShifts"
};

export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];

// key, backend'deki metabaseDashboardEnums anahtarıyla aynı olmalı.
export const METABASE_DASHBOARD_TABS = [{key: "couriers", title: "Kurye Dashboard #1"}];

export const UNPROCESSED_PERIOD_EARNING_TOOLTIP =
    "Son 32 günde cüzdana henüz aktarılmamış toplam kazancı ifade eder";

export const invoiceCutPeriodOptions = [
    {value: "semiMonthly", label: "15 Günlük"},
    {value: "monthly", label: "Aylık"}
];
